import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { InstaCardsDialogComponent } from '../components/insta-cards-dialog/insta-cards-dialog.component';
import { InstaTopicsDialogComponent } from '../components/insta-topics-dialog/insta-topics-dialog.component';
import { InstaLearn, InstaLearnTopic } from '../../common/models';
import { Observable } from 'rxjs';


@Injectable()
export class InstaLearnPostsDialogService {

  constructor(private readonly dialog: MatDialog) { }

  public openDialog(config: { cards?: InstaLearn[], index?: number, cardsSource?: Observable<InstaLearn[]>, topic?: InstaLearnTopic } = {}): MatDialogRef<InstaCardsDialogComponent> {
    const { cards, index, cardsSource, topic } = config || {};
  
    const dialog = this.dialog.open(InstaCardsDialogComponent, {
      data: { cards, activeIndex: index, cardsSource, topic },
      panelClass: 'insta-cards-dialog-panel',
      backdropClass: 'insta-cards-dialog-backdrop',
      maxHeight: '100vh',
      maxWidth: '100vw'
    });

    return dialog;
  }

  public openTopicsDialog(config: { topics: InstaLearnTopic[], index?: number, cardsSourceFn: (x: InstaLearnTopic) => Observable<InstaLearn[]>}): MatDialogRef<InstaTopicsDialogComponent> {
    const { topics, index, cardsSourceFn } = config || {};

    const items = topics.map(topic => ({
      topic, 
      cardsSource: cardsSourceFn(topic)
    }))
  
    const dialog = this.dialog.open(InstaTopicsDialogComponent, {
      data: { items, activeIndex: index },
      panelClass: 'insta-cards-dialog-panel',
      backdropClass: 'insta-cards-dialog-backdrop',
      maxHeight: '100vh',
      maxWidth: '100vw'
    });

    return dialog;
  }
}
